import Vue, { createApp, configureCompat } from 'vue';
import router from '../router';
import store from '../store';
import App from '../app';
import Auth from './plugins/auth';
import "core-js/stable";
import "regenerator-runtime/runtime";

// Vue 3 の移行ビルド（@vue/compat）で Vue 2 の挙動に合わせて動かしている。
// 既定は MODE: 2（すべて Vue 2 互換）。Vue 3 の書き方へ直し終えた機能から
// ここで個別に false にしていき、最後に @vue/compat ごと外す。
configureCompat({
  MODE: 2,
})

/* jQuery */
import jQuery from 'jquery'
global.jquery = jQuery
global.jQuery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

/* moment js */
import moment from 'moment';
window.moment = moment;

/* datetimepicker */
require('tempusdominus-bootstrap-4');
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css';
/* lightbox2 */
require("lightbox2");
import "lightbox2/dist/css/lightbox.min.css";

/* bootstrap-vue */
// bootstrap-vue 2 は Vue 3 に対応していないが、移行ビルド上では動く（2.23 で公式に対応）。
// Vue 2 のプラグインとしてグローバルの Vue に入れる。@vue/compat はグローバルの
// mixin（$bvToast / $bvModal はこれで生える）を createApp の時点で app へ写すので、
// createApp より前に入れること。
import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue, {
  BToast: {
    toaster: "b-toaster-top-center",
    autoHideDelay: 5000,
  },
})

const app = createApp(App);
app.config.globalProperties.moment = moment;

/* vue-select */
import vSelect from 'vue-select'
app.component("v-select", vSelect);

// application.scss の .vs__* の上書きより前に読み込む
import 'vue-select/dist/vue-select.css'
import '../stylesheets/application'

app.use(Auth);

// vue-meta の置き換え（metaInfo の title / titleTemplate / bodyAttrs.class だけを扱う）
import Meta from './plugins/meta'
app.use(Meta);

// レイアウト
import DefaultLayout from '../components/common/layouts/default.vue'
app.component('default-layout', DefaultLayout);

import AdminMainLayout from '../components/admin/layouts/Main.vue'
app.component('admin-main-layout', AdminMainLayout);
import AdminMainFixedBottomLayout from '../components/admin/layouts/MainFixedBottom.vue'
app.component('admin-main-fixed-bottom-layout', AdminMainFixedBottomLayout);

import EpMainLayout from '../components/ep/layouts/Main.vue'
app.component('ep-main-layout', EpMainLayout);
import EpMainFixedBottomLayout from '../components/ep/layouts/MainFixedBottom.vue'
app.component('ep-main-fixed-bottom-layout', EpMainFixedBottomLayout);
import EpSingleLayout from '../components/ep/layouts/single.vue'
app.component('ep-single-layout', EpSingleLayout);

import SuMainLayout from '../components/su/layouts/Main.vue'
app.component('su-main-layout', SuMainLayout);
import SuMainFixedBottomLayout from '../components/su/layouts/MainFixedBottom.vue'
app.component('su-main-fixed-bottom-layout', SuMainFixedBottomLayout);
import SuSingleLayout from '../components/su/layouts/single.vue'
app.component('su-single-layout', SuSingleLayout);

import PasswordToggle from '../components/common/passwordToggle.vue'
app.component('password-toggle', PasswordToggle);

import ErrorHandlers from './plugins/errorHandlers'
app.use(ErrorHandlers);

import Loading from './plugins/loading'
app.use(Loading);

import VueCookies from 'vue-cookies'
app.use(VueCookies);

// フィルター
import Filters from '../filters'
import Dotize from 'dotize'
const filters = Dotize.convert(Filters)
for(const key in filters){
  const name = key.replace(/\.default$/, '');
  app.filter(name, filters[key]);
}

app.use(store);
app.use(router);

// GoogleAnalytics
import VueGtag from 'vue-gtag'
switch (window.location.host) {
  case 'manage.sixbrain.ai':
  case 'dev.sixbrain.ai':
  case 'stg.sixbrain.ai':
    app.use(VueGtag, {
      config: {
        id: 'UA-155022883-1',
      }
    }, router);
    break;
}

document.addEventListener('DOMContentLoaded', () => {
  app.mount('#application');
});
